module.exports = __webpack_public_path__ + "static/media/demo.d4c6e708.mp4";